import { motion } from "motion/react";
import { ArrowsPointingOutIcon, PencilSquareIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { QuinnChatSummary, QuinnCopy } from "../../types";
import { QuinnHistoryMenu } from "../History";

type QuinnPanelHeaderProps = {
    chats: QuinnChatSummary[];
    activeChatId: string | null;
    title: string;
    isBusy: boolean;
    prefersReducedMotion: boolean | null;
    onExpand: () => void;
    onOpenChat: (chatId: string) => void;
    onNewChat: () => void;
    onClose: () => void;
};

export function QuinnPanelHeader({
    chats,
    activeChatId,
    title,
    isBusy,
    prefersReducedMotion,
    onExpand,
    onOpenChat,
    onNewChat,
    onClose,
}: QuinnPanelHeaderProps) {
    return (
        <header className="flex items-center gap-2 border-b border-gray-200 px-4 py-2">
            <motion.img
                src="/quinn-green-bg.png"
                alt=""
                className="h-6 w-6 shrink-0 rounded-lg"
                animate={
                    isBusy && !prefersReducedMotion
                        ? { scale: [1, 1.06, 1], opacity: [1, 0.86, 1] }
                        : { scale: 1, opacity: 1 }
                }
                transition={{ duration: 2.2, repeat: isBusy ? Infinity : 0, ease: "easeInOut" }}
            />

            <QuinnHistoryMenu
                chats={chats}
                activeChatId={activeChatId}
                title={title}
                onOpenChat={onOpenChat}
                onNewChat={onNewChat}
            />

            <button
                type="button"
                onClick={onNewChat}
                className="rounded-lg p-1.5 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700"
                aria-label={QuinnCopy.NewChat}
                title={QuinnCopy.NewChat}
            >
                <PencilSquareIcon className="h-4 w-4" />
            </button>
            <button
                type="button"
                onClick={() => onExpand()}
                className="rounded-lg p-1.5 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700"
                aria-label={QuinnCopy.Fullscreen}
                title={QuinnCopy.Fullscreen}
            >
                <ArrowsPointingOutIcon className="h-4 w-4" />
            </button>
            <button
                type="button"
                onClick={onClose}
                className="rounded-lg p-1.5 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700"
                aria-label="Quinn sluiten"
                title="Sluiten"
            >
                <XMarkIcon className="h-4 w-4" />
            </button>
        </header>
    );
}

